import i18n from '~/i18n';

export const getEmployeeRole = (
  employeeRole: string,
  allRoles: { name: string; role: string }[] | undefined
) => {
  const t = i18n.getFixedT(null, 'employees');
  return (
    allRoles?.find(({ role, name }) => role && name && role === employeeRole)?.name ??
    t(employeeRole)
  );
};
